import { render, staticRenderFns } from "./failOrderFrom.vue?vue&type=template&id=c5976774&scoped=true"
import script from "./failOrderFrom.vue?vue&type=script&lang=js"
export * from "./failOrderFrom.vue?vue&type=script&lang=js"
import style0 from "./failOrderFrom.vue?vue&type=style&index=0&id=c5976774&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5976774",
  null
  
)

export default component.exports